import React, { useId } from 'react';
import styles from './circularProgress.module.less';

interface CircularProgressProps {
    percentage: number;
}

const CircularProgress: React.FC<CircularProgressProps> = ({ percentage }) => {
    const clipId = useId();
    const validPercentage = Math.min(Math.max(percentage, 0), 100);
    
    // 计算裁剪路径
    const getClipPath = () => {
        if (validPercentage >= 100) return '';
        if (validPercentage <= 0) return 'M0 0';

        const angle = (validPercentage / 100) * 360 - 90;
        const radians = (angle * Math.PI) / 180;
        const x = 50 + 50 * Math.cos(radians);
        const y = 50 + 50 * Math.sin(radians);
        const largeArcFlag = validPercentage > 50 ? 1 : 0;

        return `M50 50 L50 0 A50 50 0 ${largeArcFlag} 1 ${x} ${y} L50 50 Z`;
    };

    return (
        <div className={styles.container}>
            <svg className={styles.svg} viewBox="0 0 100 100">
                {/* 背景圆 */}
                <circle cx="50" cy="50" r="50" fill="#f6f6f6" />
                
                {/* 进度圆 */}
                {validPercentage > 0 && (
                    <g>
                        <defs>
                            <clipPath id={clipId}>
                                <path d={getClipPath()} />
                            </clipPath>
                        </defs>
                        <circle
                            cx="50"
                            cy="50"
                            r="50"
                            fill="#d9eafd"
                            clipPath={`url(#${clipId})`}
                        />
                    </g>
                )}
            </svg>
        </div>
    );
};

export default CircularProgress;